module.exports = require('./helpers/bundle-url').getBundleURL('lbB2N') + "vacs-admin-car-list-pages-snippet-icon.67d35601.svg";